import React, { Fragment } from "react";
import { Button, CardHeader } from "reactstrap";
import H4 from "../headings/H4Element";
import P from "../paragraph";
import { CommonCardHeaderProp } from "../../types/common-elements/CommonElementsTypes";

const CardHeaderCommon: React.FC<CommonCardHeaderProp> = ({ title, span, headClass, icon, tagClass, Btn_text, Btn_className,Btn_onClick }) => {
  return (
    <CardHeader className={`${headClass ? headClass : ""} pb-0 d-flex justify-content-between align-items-center`}>
      <div>
        <H4 className={tagClass ? tagClass : ""}>{icon && icon}{title}</H4>
        {span && (
          <P className="f-m-light mt-1">
            {span.map((data, index) => (
              <Fragment key={index}>
                {data?.text} {data.code && <code>{data.code}</code>} {data.mark && <mark>{data.mark}</mark>}
              </Fragment>
            ))}
          </P>
        )}
      </div>
      {Btn_text && (
        <Button className={Btn_className} color="primary" onClick={Btn_onClick}>
          {Btn_text}
        </Button>
      )}
    </CardHeader>
  );
};

export default CardHeaderCommon;